export enum ComparisonType {
    previousPeriod = "previousPeriod",
    meanOfPeriod = "meanOfPeriod",
    previousYear = "previousYear",
}

export enum ComparisonMode {
    dateToDate = "dateToDate",
    tantamount = "tantamount",
    auto = "auto",
}

export enum TrendDuration {
    untilDate = "untilDate",
    completePeriod = "completePeriod",
}

export enum TrendScale {
    global = "global",
    dynamic = "dynamic",
}

export enum RevenueBreakdown {
    global = "global",
    daily = "daily",
}
